import { render } from "./ParametrosComponent.vue?vue&type=template&id=3cd3abca"
import script from "./ParametrosComponent.vue?vue&type=script&lang=js"
export * from "./ParametrosComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__